/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ResourceAssignmentForDeploymentSwagger, ResourceAssignmentForRegionSwagger } from 'src/core/services/resourceAssignmentSwaggers';
import { ResourceAssignmentStore } from 'src/core/stores/ResourceAssignmentStore';
import { Region } from 'src/core/types/regionTypes';
import { getResourceInfo, updateRegionResourceAssignment } from 'src/core/utils/resourceAssignmentUtils';

export const resourceAssignmentSwaggersToRegionDeploymentStores = ({
    supportedRegions,
    defaultRegionInfo,
    assignedResources,
    getSubscriptionName
}: {
    supportedRegions: { [s: string]: string };
    assignedResources: ResourceAssignmentForRegionSwagger[];
    getSubscriptionName: (subscriptionId: string) => string;
    defaultRegionInfo: { region: Region; azureResourceId: string; resourceName: string; subscriptionId: string; subscriptionName: string };
}) => {
    const regionDeploymentItems: ResourceAssignmentStore[] = Object.entries(supportedRegions).map(([key, value]) => ({
        id: key as Region,
        regionName: value,
        resourceName: null,
        subscriptionId: null,
        azureResourceId: null,
        subscriptionName: null,
        isDefaultResource: key === defaultRegionInfo.region
    }));

    assignedResources.forEach(resource => {
        const { subscriptionId, resourceName } = getResourceInfo(resource.azureResourceId);

        updateRegionResourceAssignment(
            resource.region as Region,
            {
                resourceName,
                subscriptionId,
                id: resource.region as Region,
                azureResourceId: resource.azureResourceId,
                regionName: supportedRegions[resource.region],
                subscriptionName: getSubscriptionName(subscriptionId),
                isDefaultResource: resource.region === defaultRegionInfo.region
            },
            regionDeploymentItems
        );
    });

    return regionDeploymentItems;
};

export const deploymentAssignmentsSwaggerToResourceAssignmentsSwagger = (
    deploymentAssignment: ResourceAssignmentForDeploymentSwagger[]
): ResourceAssignmentForRegionSwagger[] =>
    deploymentAssignment?.map(assignment => ({
        region: assignment.region,
        azureResourceId: assignment.resourceId
    }));
